import { FrenchDatePicker } from "@/components/FrenchDatePicker";
import { FrDateInput } from "@/components/FrDateInput";
import { DATE_SHORTCUTS, isoOffset, fmtDate } from "@/lib/helpers";

export function DateQuickPick({ value, onChange, testidPrefix = "date" }) {
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-2">
        {DATE_SHORTCUTS.map((s) => {
          const val = isoOffset(s.days);
          const active = value === val;
          return (
            <button key={s.days} type="button" data-testid={`${testidPrefix}-shortcut-${s.days}`} onClick={() => onChange(val)}
              className={`h-12 rounded-2xl border-2 font-bold text-sm active:scale-[0.98] transition-transform ${active ? "bg-orange-500 text-white border-orange-500" : "bg-orange-50 text-orange-700 border-orange-200"}`}>
              {s.label}
            </button>
          );
        })}
      </div>
      <FrDateInput value={value} onChange={onChange} mode="future" testid={`${testidPrefix}-typed`} placeholder="Ou tapez : JJ/MM/AAAA" />
      <FrenchDatePicker value={value} onChange={onChange} testid={`${testidPrefix}-calendar`} minToday />
      {value && <p className="text-sm text-slate-500">Récupérable à partir du <b>{fmtDate(value)}</b></p>}
    </div>
  );
}
